import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'material-ui-snackbar-provider';
import CloseIcon from '@mui/icons-material/Close';
import { LinearProgress } from '@mui/material';
import cx from 'classnames';

import useDebounce from '../../../helpers/useDebounce';
import styles from './OrgUserInput.module.scss';
import { isEmail } from '../../../helpers';
import { getAllUsers } from '../../../api';
import { USER } from '../../../enums';

type TOrgUserInput = {
  index: number;
  removeUser: (id: number) => void;
  data: { email: string; username: string; id: number };
  setUser: (data: { email: string; username: string; id: number }) => void;
  deleteIconClass?: string;
};

const OrgUserInput: React.FC<TOrgUserInput> = ({ index, removeUser, data, setUser, deleteIconClass }) => {
  const [loading, setLoading] = useState(false);
  const notification = useSnackbar();
  const [value, setValue] = useState({
    email: '',
    username: '',
    id: data.id,
  });
  const remove = () => {
    removeUser(data.id);
  };
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue({
      ...value,
      [e.target.name]: e.target.value,
    });
  };

  const fetchSearch = async (email: string) => {
    try {
      setLoading(true);
      const res = await getAllUsers(0, 9000, email.toLocaleLowerCase());
      const user = res.data.documents.find((u: USER) => u.email === email);
      if (user) {
        notification.showMessage(
          `User ${email} is already exist (role: ${user.role.title.replace('Organization', 'Organisation')}, username: ${
            user?.username ? user.username : 'no username'
          })`,
        );
        setValue({
          ...value,
          username: user?.username ? user.username : '',
          email: user.email,
        });
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  const debouncedSearch = useDebounce(value.email, 500);
  const debouncedValue = useDebounce(value, 500);
  useEffect(() => {
    if (value.email && isEmail(value.email)) {
      fetchSearch(value.email);
    }
  }, [debouncedSearch]);
  useEffect(() => {
    setUser(value);
  }, [debouncedValue]);

  return (
    <div key={data.id} className={styles.relativeContainer}>
      <input value={value.email} required type="email" name="email" className={styles.field} placeholder="Email" onChange={onChange} />
      <input
        value={value.username}
        required
        type="text"
        name="username"
        className={styles.field}
        placeholder="Username"
        onChange={onChange}
      />
      <div id={`${index}`} onClick={remove} className={cx(styles.deleteIcon, deleteIconClass)}>
        <CloseIcon />
      </div>
      {loading && <LinearProgress />}
    </div>
  );
};

export default OrgUserInput;
